export function isEmptyMessage(message: string): boolean {
  const emptyMessages = ['-', '--', '---'];
  return !message || emptyMessages.some(emptyMessage => message === emptyMessage);
}
